$(document).ready(function(){
  
  var discountString = window.location.search;
  if(discountString.includes('customer')){
  	window.open('https://cdn.shopify.com/s/files/1/0031/7007/4737/files/Healthy_Nutrition_guide.pdf', '_blank');
  }
  
//   $('#Subscribe').on('click', function(event){
//     event.preventDefault();
//     //alert('Click hoise monu');
//   	//$('#guideDownload').trigger('click');
//     //window.open('https://cdn.shopify.com/s/files/1/0031/7007/4737/files/Healthy_Nutrition_guide.pdf', '_blank');
   
//     $('#guideDownload')[0].click();
    
//     $('#Contact_feature-row').submit();
//   });
});

//https://www.befitnutrition.com/?contact%5Btags%5D=newsletter&form_type=customer
//https://www.befitnutrition.com/?customer_posted=true